import { createCrudHooks } from '../../../shared/api/crud-hooks';
import { tiposHoraApi } from './api';
import type { TipoHoraDto, TipoHoraInput, TipoHoraListItem } from './types';

export const tiposHoraHooks = createCrudHooks<TipoHoraListItem, TipoHoraDto, TipoHoraInput>({
  queryKey: ['tipos-hora'],
  api: tiposHoraApi,
});
